import {ChangeDetectorRef, Component, forwardRef, Input, OnInit} from "@angular/core";
import {AbstractVisbosControl} from "../abstract-visbos-control";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {appInjector} from "../../../../../index";
import {Address} from "../../../model/address.type";
import {City} from "../../../model/city.type";
import {AddressService} from "../../../services/address.service";
import {TypeaheadMatch} from "ngx-bootstrap";
import {ApolloQueryObservable} from "apollo-angular";

@Component({
  selector: 'vb-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => AddressFormComponent)}]
})
export class AddressFormComponent extends AbstractVisbosControl<Address, FormGroup> implements OnInit {

  @Input()
  withAddressNameField: boolean = false;

  public asyncSelected: string;
  public typeaheadLoading: boolean;
  public typeaheadNoResults: boolean;

  cities$: ApolloQueryObservable<City[]>;
  selectedCity: City;

  constructor(private cityService: AddressService, fb?: FormBuilder, cd?: ChangeDetectorRef) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();
    this.cities$ = this.cityService.getCities();
  }

  buildControlContent(): FormGroup {
    return AddressFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      address_name: [null],
      street: [null, Validators.required],
      number: [null],
      city: fb.group({
        cuid: [null],
        zip: [null, Validators.required],
        town: [null, Validators.required],
        country_id: [null]
      }),
    });

  }

  public setDefaultValues(item?: Address): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      address_name: this.setValue(item, 'address_name'),
      street: this.setValue(item, 'street'),
      number: this.setValue(item, 'number'),
      city: {
        cuid: this.setValue(item, 'city.cuid', AbstractVisbosControl.cuid()),
        zip: this.setValue(item, 'city.zip'),
        town: this.setValue(item, 'city.town')
      }
    };
  }

  public changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  public changeTypeaheadNoResults(e: boolean): void {
    this.typeaheadNoResults = e;
  }

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    this.control.get('city.town').setValue(e.item.town);
    this.control.get('city.town').markAsTouched();

    this.control.get('city.country_id').setValue(e.item.country.cuid);
    this.control.get('city.country_id').markAsTouched();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/address-form/address-form.component.ts